import { OfflineOrderProduct } from '../../orderProduct/OfflineOrderProduct';
import OfflineOrderRule from '../OfflineOrder.rule';
import {
  OfflineOrderRulesReturnMap,
  OfflineOrderRulesTo,
  OrderProductWithError,
  ValidateOfflineOrderRuleParams,
} from '../OfflineOrderRules.types';

export default abstract class BaseOrderProductRule
  implements OfflineOrderRule<OfflineOrderRulesTo.VALIDATE_PRODUCTS>
{
  abstract validate({
    order,
  }: ValidateOfflineOrderRuleParams): OfflineOrderRulesReturnMap[OfflineOrderRulesTo.VALIDATE_PRODUCTS];

  protected readonly orderProductsWithError: OrderProductWithError[] = [];

  protected pushOrderProductWithError(
    orderProduct: OfflineOrderProduct,
    extra?: OrderProductWithError['extra'],
  ) {
    this.orderProductsWithError.push({
      productId: orderProduct.product.id,
      productColorId: orderProduct.productColor.id,
      availability: orderProduct.availability,
      deliveryWindowId: orderProduct.deliveryWindow?.id,
      extra,
    });
  }
}
